import Vue from 'vue';
import VueCompositionApi, { reactive } from '@vue/composition-api';
import { getStory } from '@/storyblok';

import { Stateful } from './common';

Vue.use(VueCompositionApi);

export type ImageTargetTrack = {
  imageTargetName: string;
  audioTracks: {
    filename: string;
  }[];
  activationCodes?: {
    audioTrackActivationCodes: string[];
  };
};

export type StoryblokImageTargetTracksLibState = {
  imageTargetTracks: ImageTargetTrack[];
};

export const DefaultImageTargetTracksLibState: StoryblokImageTargetTracksLibState = {
  imageTargetTracks: [],
};

export type StoryblokImageTargetTracksLibModel = Stateful<StoryblokImageTargetTracksLibState> & {
  type: 'StoryblokImageTargetTracksLibModel';
};

export function createStoryblokImageTargetTracksLibModel(state = DefaultImageTargetTracksLibState): StoryblokImageTargetTracksLibModel {
  // deep copy trick with json serialization
  const _state: StoryblokImageTargetTracksLibState = reactive(JSON.parse(JSON.stringify(state)));

  // fetch current audio track info
  async function fetchImageTargetTracks() {
    const story = await getStory('/image-target-tracks', 'published');
    _state.imageTargetTracks = story.content.imageTargetTracks;
  }
  fetchImageTargetTracks();

  return {
    type: 'StoryblokImageTargetTracksLibModel',
    state: _state,
  };
}
